import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  variant?: 'default' | 'compact' | 'featured';
}

export default function VideoCard({ video, variant = 'default' }: VideoCardProps) {
  const isFeatured = variant === 'featured';
  const isCompact = variant === 'compact';

  return (
    <Link
      to={`/article/${video.id}`}
      className={`group block cursor-pointer ${isFeatured ? 'col-span-2 row-span-2' : ''}`}
      data-product-shop
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-200 ${
          isFeatured ? 'aspect-video' : isCompact ? 'aspect-[16/9]' : 'aspect-[16/10]'
        }`}
      >
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        <div className="absolute top-3 left-3 flex items-center gap-2">
          {video.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-white">
              热门
            </span>
          )}
          {video.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-white">
              新上线
            </span>
          )}
        </div>

        <span className="absolute bottom-3 right-3 px-2 py-0.5 text-xs font-medium rounded bg-black/60 text-white">
          {video.duration}
        </span>

        {isFeatured && (
          <div className="absolute bottom-3 left-4 right-16">
            <h3 className="text-lg md:text-xl font-bold text-white mb-1 line-clamp-1">
              {video.title}
            </h3>
            <p className="text-sm text-white/70 line-clamp-2">
              {video.description}
            </p>
          </div>
        )}

        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-2xl md:text-3xl text-primary-500 ml-0.5"></i>
          </div>
        </div>
      </div>

      {!isFeatured && (
        <div className="mt-2.5">
          <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
            {video.title}
          </h3>
          <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
            <span>{video.category}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {video.views >= 10000 ? `${(video.views / 10000).toFixed(0)}万` : video.views}
            </span>
            <span className="flex items-center gap-0.5">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {video.rating}
            </span>
          </div>
        </div>
      )}
    </Link>
  );
}